import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-253dea54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }


import LoginView from '@/views/LoginView.vue'
import LandingView from '@/views/LandingView.vue'
import StartpageView from '@/views/StartpageView.vue'

import { useAuthStore } from '@/stores/authStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  props: {
  textClass: {
    type: Object
  },
  columnSizes: {
    type: Object
  },
  paddingClass: {
    type: String
  }
},
  setup(__props) {

const props = __props

const AuthStore = useAuthStore()

return (_ctx: any,_cache: any) => {
  return (!_unref(AuthStore).isAuthenticated)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoginView, {
          textClass: props.textClass,
          columnSizes: __props.columnSizes
        }, null, 8, ["textClass", "columnSizes"])
      ]))
    : (!_unref(AuthStore).chosenRepresentative)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LandingView, {
            textClass: props.textClass,
            columnSizes: __props.columnSizes
          }, null, 8, ["textClass", "columnSizes"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(StartpageView, {
            textClass: props.textClass,
            columnSizes: __props.columnSizes,
            paddingClass: __props.paddingClass
          }, null, 8, ["textClass", "columnSizes", "paddingClass"])
        ]))
}
}

})